import { IPetItemResponse } from "../../services/pet-list/pet-list.interface";
import {
  ILocationItemResponse,
} from "../../services/edit-hospital-location/edit-hospital-location.interface";
import {
  actionTypes,
  SelectedSlot,
  PetBookingData,
  UrgentVisitBookingResponse,
  UrgentVisitStep,
} from "./urgentVisit.actions";

export interface IUrgentVisitState {
  currentStep: UrgentVisitStep;
  selectedPets: IPetItemResponse[];
  selectedSlot: SelectedSlot | null;
  selectedLocationId: string | null;
  selectedLocationDetails: ILocationItemResponse | null;
  homeLocationId: string | null;
  petBookingData: Record<string, PetBookingData>;
  currentPetIndex: number;
  bookingResponse: UrgentVisitBookingResponse | null;
  promoCodes: string[];
  timeZone: string;
  slotUnavailableMessage: string;
  isMultiPetOwner: boolean;
  selectedDate: number | null;
  rescheduleAppointmentId: string | null;
  petAppointmentMap: Record<string, string>;
}

const initialState: IUrgentVisitState = {
  currentStep: UrgentVisitStep.PET_SELECTION,
  selectedPets: [],
  selectedSlot: null,
  selectedLocationId: null,
  selectedLocationDetails: null,
  homeLocationId: null,
  petBookingData: {},
  currentPetIndex: 0,
  bookingResponse: null,
  promoCodes: [],
  timeZone: "",
  slotUnavailableMessage: "",
  isMultiPetOwner: false,
  selectedDate: null,
  rescheduleAppointmentId: null,
  petAppointmentMap: {},
};

export const urgentVisitReducer = (
  state: IUrgentVisitState = initialState,
  action: { type: string; payload: any },
): IUrgentVisitState => {
  switch (action.type) {
  case actionTypes.UV_SET_STEP:
    return { ...state, currentStep: action.payload };

  case actionTypes.UV_SET_SELECTED_PETS:
    return { ...state, selectedPets: action.payload };

  case actionTypes.UV_SET_SELECTED_SLOT:
    return { ...state, selectedSlot: action.payload };

  case actionTypes.UV_SET_SELECTED_LOCATION:
    return {
      ...state,
      selectedLocationId: action.payload.locationId,
      selectedLocationDetails: action.payload.locationDetails,
    };

  case actionTypes.UV_SET_HOME_LOCATION_ID:
    return { ...state, homeLocationId: action.payload };

  case actionTypes.UV_SET_PET_REASONS:
    return {
      ...state,
      petBookingData: {
        ...state.petBookingData,
        [action.payload.petId]: {
          ...state.petBookingData[action.payload.petId],
          selectedReasons: action.payload.reasons,
          additionalNotes:
            state.petBookingData[action.payload.petId]
              ?.additionalNotes ?? "",
        },
      },
    };

  case actionTypes.UV_SET_PET_NOTES:
    return {
      ...state,
      petBookingData: {
        ...state.petBookingData,
        [action.payload.petId]: {
          ...state.petBookingData[action.payload.petId],
          selectedReasons:
            state.petBookingData[action.payload.petId]
              ?.selectedReasons ?? [],
          additionalNotes: action.payload.notes,
        },
      },
    };

  case actionTypes.UV_SET_CURRENT_PET_INDEX:
    return { ...state, currentPetIndex: action.payload };

  case actionTypes.UV_SET_BOOKING_RESPONSE:
    return { ...state, bookingResponse: action.payload };

  case actionTypes.UV_SET_PROMO_CODES:
    return { ...state, promoCodes: action.payload };

  case actionTypes.UV_SET_TIMEZONE:
    return { ...state, timeZone: action.payload };

  case actionTypes.UV_SET_SLOT_UNAVAILABLE_MESSAGE:
    return { ...state, slotUnavailableMessage: action.payload };

  case actionTypes.UV_SET_IS_MULTI_PET_OWNER:
    return { ...state, isMultiPetOwner: action.payload };

  case actionTypes.UV_SET_SELECTED_DATE:
    return { ...state, selectedDate: action.payload };

  case actionTypes.UV_SET_RESCHEDULE_APPOINTMENT_ID:
    return { ...state, rescheduleAppointmentId: action.payload };

  case actionTypes.UV_SET_PET_APPOINTMENT_MAP:
    return { ...state, petAppointmentMap: action.payload };

  case actionTypes.UV_RESET:
    return initialState;

  default:
    return state;
  }
};
